// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2Xp3I","name":"ConsentHeader_name__3teDz","birthday":"ConsentHeader_birthday__253Np","skeleton":"ConsentHeader_skeleton__3bfnA"};